import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const SupportPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="flex items-center gap-3 mb-8">
        <Link to="/dashboard">
          <Button variant="outline" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>
        <div className="flex items-center gap-3">
          <Users className="w-8 h-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold">Support & Help</h1>
            <p className="text-muted-foreground">Get assistance with your ICX Registry account</p>
          </div>
        </div>
      </div>

      <div className="grid gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Contact Support</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              Need help with your carbon credit projects or account? Our support team is here to assist you.
            </p>
            <div className="space-y-2">
              <p><strong>Email:</strong> support@icx.earth</p>
              <p><strong>Phone:</strong> +91 (your phone number)</p>
              <p><strong>Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM IST</p>
            </div>
            <Button variant="outline" disabled>
              Contact Support (Coming Soon)
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Frequently Asked Questions</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-4">
              <div>
                <h4 className="font-medium">How do I register a new carbon credit project?</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Navigate to your Project Developer dashboard and click "Register New Project" to start the process.
                </p>
              </div>
              <div>
                <h4 className="font-medium">How do I purchase carbon credits?</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Browse the marketplace to find verified projects and purchase credits directly from developers.
                </p>
              </div>
              <div>
                <h4 className="font-medium">What verification standards are supported?</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  We support various international standards including Verra VCS, Gold Standard, and others.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SupportPage;